<mat-toolbar>
    <div class="container">
        <div fxLayout="row" fxHide fxShow.gt-xs>
            <div class="text-left" fxFlex="33"> ©{{ currentYear }} Aptask, All Rights Reserved.</div>
            <div class="text-center" fxFlex="34"><span style="color: blue;">Build : </span>{{ buildNumber }}</div>
            <div class="text-right" fxFlex="15"> Version: {{ versionNumber }}</div>
            <div class="text-right" fxFlex="15"> Build-Date: {{ buildDate }}</div>
        </div>
    </div>
</mat-toolbar>
